import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import ApplicationFrame from './components/ApplicationFrame/ApplicationFrame';
import wrapLazyLoad from './shared/hocs/wrapLazyLoad';

const InboundLinkPage = wrapLazyLoad(lazy(() => import('./pages/InboundLink/InboundLinkPage')));
const CheckInPage = wrapLazyLoad(lazy(() => import('./pages/CheckIn/CheckInPage')));
const ActivePassPage = wrapLazyLoad(lazy(() => import('./pages/PassPages/ActivePassPage')));
const PrePassPage = wrapLazyLoad(lazy(() => import('./pages/PassPages/PrePassPage')));
const InvitationPrePassPage = wrapLazyLoad(lazy(() => import('./pages/PreRegistration/InvitationPassPage')));
const PreRegistrationPage = wrapLazyLoad(lazy(() => import('./pages/PreRegistration/PreRegistrationPage')));

export default function App() {
  return (
    <ApplicationFrame>
      <Routes>
        <Route path='/:teamId/pass/:passId' element={<ActivePassPage />} />
        <Route path='/:teamId/invitation/:invitationId/pass' element={<InvitationPrePassPage />} />
        <Route path='/:teamId/invitation/:invitationId' element={<PreRegistrationPage />} />
        <Route path='/:teamId/:checkinToken/pass' element={<PrePassPage />} />
        <Route path='/:teamId/:checkinToken' element={<CheckInPage />} />
        <Route path='*' element={<InboundLinkPage />} />
      </Routes>
    </ApplicationFrame>
  );
}
